import React, { useState, useEffect, useRef } from "react";
import { ShoppingCart, Menu } from "lucide-react";
import { useCart } from "../../../context/CartContext";
import MiniCart from "../MiniCart/MiniCart";
import UserMiniPanel from "../UserMiniPanel/UserMiniPanel";
import "./HomeHeader.css";
import { useAuth } from "../../../context/AuthContext";
import SearchSuggestions from "../SearchSuggestions/SearchSuggestions";

import LoginModal from "../../Auth/LoginModal";

export default function HomeHeader({ onMobileMenuClick }) {
  const [loginOpen, setLoginOpen] = useState(false);
  const cartWrapperRef = useRef(null);
  const [isMobile, setIsMobile] = useState(
    () => window.matchMedia("(max-width: 640px)").matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 640px)");

    const handleChange = (event) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener("change", handleChange);

    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);

  const handleCartClick = () => {
    if (isMobile) {
      setIsMiniCartOpen((previous) => !previous);
      return;
    }

    window.location.href = "/cart";
  };

  const handleLogin = (user) => {
    console.log("Logged in user:", user);

    // Later:
    // update AuthContext
  };

  const { user, loading: authLoading } = useAuth();
  const isAuthenticated = !authLoading && !!user;
  const [search, setSearch] = useState("");

  const [isMiniCartOpen, setIsMiniCartOpen] = useState(false);

  const { cart = [] } = useCart();

  const cartCount = cart.reduce(
    (total, item) => total + Number(item?.qty || 0),
    0,
  );



  const handleSearchSubmit = (query) => {
    window.location.href = `/products?search=${encodeURIComponent(query)}`;
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!isMiniCartOpen) return;

      // Only needed for mobile
      if (window.innerWidth > 640) return;

      if (
        cartWrapperRef.current &&
        !cartWrapperRef.current.contains(event.target)
      ) {
        setIsMiniCartOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleOutsideClick);

    return () => {
      document.removeEventListener("pointerdown", handleOutsideClick);
    };
  }, [isMiniCartOpen]);



  return (
    <header className="home-header">
      {/* <div className="home-header__topbar">
        <div className="home-container home-header__topbar-inner">
          <nav aria-label="لینک‌های بالای سایت">
            <a href="/contact">تماس با ما</a>
            <a href="/about">درباره ما</a>
            <a href="/faq">سوالات متداول</a>
            <a href="/shipping">راهنمای خرید</a>
            <a href="/articles">مجله سلامت</a>
          </nav>
        </div>
      </div> */}

      <div className="home-header__main">
        <div className="home-container home-header__main-inner">
          <a href="/" className="home-header__brand" aria-label="کافه دارو">
            <span className="home-header__brand-mark">
              <img src="/images/logo.png" alt="کافه دارو" />
            </span>
            <span className="home-header__brand-copy">
              <strong>کافه دارو</strong>
            </span>
          </a>

          <SearchSuggestions
            value={search}
            onChange={setSearch}
            onSubmit={handleSearchSubmit}
          />

          <div className="home-header__actions">


            <div
              ref={cartWrapperRef}
              className="home-header__cart-wrapper"
              onMouseEnter={() => {
                if (!isMobile) {
                  setIsMiniCartOpen(true);
                }
              }}
              onMouseLeave={() => {
                if (!isMobile) {
                  setIsMiniCartOpen(false);
                }
              }}
            >

              <button
                type="button"
                className="home-header__action"
                aria-label="سبد خرید"
                aria-expanded={isMiniCartOpen}
                onClick={handleCartClick}
              >
                <ShoppingCart size={19} />

                {cartCount > 0 && (
                  <span className="home-header__badge">
                    {cartCount > 99 ? "99+" : cartCount}
                  </span>
                )}
              </button>

              {isMiniCartOpen && (
                <MiniCart onClose={() => setIsMiniCartOpen(false)} />
              )}

            </div>



            <UserMiniPanel
              user={user}
              isAuthenticated={isAuthenticated}
              loading={authLoading}
              onLoginClick={() => setLoginOpen(true)}
            />

            <button
              type="button"
              className="home-header__action home-header__mobile-menu"
              aria-label="منو"
              onClick={onMobileMenuClick}
            >
              <Menu size={19} />
            </button>
          </div>
        </div>
      </div>

      <LoginModal
        open={loginOpen}
        onClose={() => setLoginOpen(false)}
        onLogin={handleLogin}
      />
    </header>
  );
}
